import { render, staticRenderFns } from "./GroupView.vue?vue&type=template&id=29bc803c"
import script from "./GroupView.vue?vue&type=script&lang=ts"
export * from "./GroupView.vue?vue&type=script&lang=ts"
import style0 from "./GroupView.vue?vue&type=style&index=0&id=29bc803c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports